import { Flex, Table, Tag } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import axiosInstance from "../axios";
import { useEffect, useState } from "react";
import NeedHelpDrawer from "../components/NeedHelpDrawer";

dayjs.extend(utc);
dayjs.extend(timezone);

const IST = "Asia/Kolkata";

const NeedHelp = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 200,
  });
  const [open, setOpen] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, []);

  const fetchData = async (page, limit) => {
    setLoading(true);
    const response = await axiosInstance.get(`/v1/cre/need-help`, {
      params: {
        page,
        limit,
      },
    });
    setData(
      response.data.data?.map((item) => ({
        ...item,
        fullName: `${item.first_name} ${item.last_name}`,
        createdAt: dayjs.utc(item.created_at).tz(IST).format("DD-MM-YYYY HH:mm:ss"),
      }))
    );
    setPagination({
      ...pagination,
      current: page,
      pageSize: limit,
      total: response.data.meta.total,
    });
    setLoading(false);
  };
  const showDrawer = (record) => {
    setActiveRow(record);
    setOpen(true);
  };

  const getStatusColor = (status) => {
    const colors = {
      PENDING: "orange",
      IN_PROGRESS: "blue",
      RESOLVED: "green",
      CANCELLED: "red",
    };
    return colors[status] || "default";
  };
  const columns = [
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
    },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
      width: 200,
      render: (_, record) => {
        return (
          <Flex
            align="center"
            style={{
              color: record?.is_paid ? "#59d559" : "#262121",
              fontWeight: record?.is_paid ? "bolder" : "",
              cursor: "pointer",
              textTransform: "capitalize",
              minHeight: "30px",
            }}
            onClick={() => showDrawer(record)}
          >
            {record?.fullName}
          </Flex>
        );
      },
    },
    {
      title: "Help",
      dataIndex: "help",
      key: "help",
    },
    {
      title: "Description",
      dataIndex: "custom_text",
      key: "custom_text",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={getStatusColor(status)}>{status?.replace("_", " ")}</Tag>
      ),
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (pagination.current) {
      fetchData(pagination.current, pagination.pageSize);
    }
  };

  const handleStatusUpdate = () => {
    // Refresh current page data after status update
    fetchData(pagination.current, pagination.pageSize);
  };

  return (
    <>
      <Flex
        style={{
          overflow: "scroll",
          marginLeft: "5px",
        }}
      >
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          pagination={{
            ...pagination,
            onChange: handleTableChange,
            showSizeChanger: true,
            pageSizeOptions: [10, 15, 20, 25, 50, 100, 150, 200, 250, 500],
          }}
          loading={loading}
          onChange={handleTableChange}
        />
      </Flex>
      {open && (
        <NeedHelpDrawer
          activeRow={activeRow}
          open={open}
          setOpen={setOpen}
          onStatusUpdate={handleStatusUpdate}
        />
      )}
    </>
  );
};

export default NeedHelp;
